import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import uuid from 'uuid';
import { APPLE_SIGNIN_POST_MESSAGE_SOURCE } from "../../constants";
import { AppleAuthErrors } from "../../constants/internal";
import { openPopup } from "./popup";
/**
 * Opens a new window which shows the Sign in with Apple authorization flow
 * at https://appleid.apple.com/auth/authorize.
 *
 * @returns {Promise} A promise tracking the process:
 *  - resolves with the Apple auth response (authorization code, user info)
 *  - rejects with {string} error: one of `AppleAuthErrors` or the error from Apple
 */

var showApplePopup = function showApplePopup() {
  return new Promise(function (resolve, reject) {
    var state = uuid.v4();
    var popup = openPopup(state);
    var windowCloseInterval;
    var messageHandler; // on either success or fail make sure to clean up any polling, event listeners, etc

    var makeCleanupHandler = function makeCleanupHandler(cb) {
      return function () {
        window.clearInterval(windowCloseInterval);
        window.removeEventListener('message', messageHandler);
        if (!popup.closed && popup.close) popup.close();
        cb.apply(void 0, arguments);
      };
    };

    var handleResolve = makeCleanupHandler(resolve);
    var handleReject = makeCleanupHandler(reject); // while window is open poll to check if it's been closed by the user

    windowCloseInterval = window.setInterval(function () {
      if (popup.closed) {
        handleReject(AppleAuthErrors.POPUP_CLOSED_BY_USER);
      }
    }, 200); // handler for `postMessage` from popup-->parent window

    messageHandler = function messageHandler(message) {
      // ignore messages not from redirect handler page
      if (message.data.source !== APPLE_SIGNIN_POST_MESSAGE_SOURCE) return; // only allow messages from the same domain

      if (message.origin !== window.location.origin) {
        handleReject(AppleAuthErrors.CROSS_ORIGIN_POST_MESSAGE); // if the apple flow returns an `error` field reject with the error
        // https://developer.apple.com/documentation/signinwithapplejs/configuring_your_webpage_for_sign_in_with_apple
      } else if (_get(message, 'data.responseData.error')) {
        handleReject(message.data.responseData.error); // verify the state param to prevent XSRF
      } else if (_get(message, 'data.responseData.state') !== state) {
        handleReject(AppleAuthErrors.STATE_PARAM_MISMATCH);
      } else {
        handleResolve(_objectSpread(_objectSpread({}, message.data.responseData), {}, {
          redirect_uri: "".concat(window.location.origin, "/home/apple-signin/redirect-handler.html")
        }));
      }
    };

    window.addEventListener('message', messageHandler);
  });
};
/**
 * If the user was required to enter a password ("REQUIRES_PASSWORD" error), we can
 * avoid showing Apple Sign-in auth again by passing appropriate params to Identity.
 *
 * @param {string} email
 * @param {string} code
 *
 * @return {Promise}
 */


var bypassAppleAuth = function bypassAppleAuth(email, code) {
  return new Promise(function (resolve) {
    return resolve({
      user: {
        email: email
      },
      code: code
    });
  });
};

var getWebAppleTokenInfo = function getWebAppleTokenInfo() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      usingPassword = _ref.usingPassword,
      email = _ref.email,
      code = _ref.code;

  var shouldBypassPopup = usingPassword && email && code;
  return shouldBypassPopup ? bypassAppleAuth(email, code) : showApplePopup();
};

export default getWebAppleTokenInfo;